import { getOneGeniusApiBaseUrl } from "./getOneGeniusApiBaseUrl";
function readFees(value) {
    if (typeof value === "number") {
        return Number.isFinite(value) ? String(value) : undefined;
    }
    if (typeof value === "string")
        return value.trim() || undefined;
    return undefined;
}
function readSchoolFees(payload) {
    const data = payload.data;
    const fees = data && typeof data === "object" ? readFees(data.fees) : undefined;
    if (fees)
        return fees;
    const direct = payload.schoolFees?.trim() || payload.school_fees?.trim() || undefined;
    if (direct)
        return direct;
    if (!data || typeof data !== "object")
        return undefined;
    const fromData = (typeof data.schoolFees === "string" && data.schoolFees.trim()) ||
        (typeof data.school_fees === "string" && data.school_fees.trim()) ||
        (typeof data.category === "string" && data.category.trim()) ||
        (typeof data.category_name === "string" && data.category_name.trim()) ||
        undefined;
    return fromData || undefined;
}
/**
 * GET with Authorization + accesstoken via XHR.
 * RN `fetch` can drop the Authorization header on Android; XHR does not.
 */
function getCategoryDetails(url, bearer, rawToken, platform) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.setRequestHeader("Authorization", bearer);
        xhr.setRequestHeader("accesstoken", rawToken);
        xhr.setRequestHeader("platform", platform);
        xhr.setRequestHeader("x-platform", platform);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.onload = () => {
            resolve({ status: xhr.status, text: xhr.responseText ?? "" });
        };
        xhr.onerror = () => {
            reject(new Error("Genius school category network error"));
        };
        xhr.ontimeout = () => {
            reject(new Error("Genius school category request timed out"));
        };
        xhr.timeout = 30000;
        xhr.send();
    });
}
/** Best-effort One Genius school category for LSQ mx_Custom_12. Never throws. */
export async function fetchGeniusSchoolCategoryDetails(args) {
    const schoolCode = args.schoolCode.trim();
    const rawToken = args.accessToken.replace(/^Bearer\s+/i, "").trim();
    if (!schoolCode || !rawToken) {
        console.warn("[GeniusSchoolCategory] skipped: missing input", {
            hasSchoolCode: Boolean(schoolCode),
            hasToken: Boolean(rawToken),
        });
        return null;
    }
    const baseURL = getOneGeniusApiBaseUrl().replace(/\/+$/, "");
    const url = `${baseURL}/api/v1/student/schools/${encodeURIComponent(schoolCode)}/category-details`;
    const platform = args.platform?.trim() || "web";
    const bearer = `Bearer ${rawToken}`;
    try {
        console.log("[GeniusSchoolCategory] GET", { url, schoolCode, platform });
        const response = await getCategoryDetails(url, bearer, rawToken, platform);
        console.log("[GeniusSchoolCategory] response", {
            status: response.status,
            text: response.text,
        });
        if (response.status < 200 || response.status >= 300) {
            console.warn("[GeniusSchoolCategory] API failed", {
                status: response.status,
            });
            return null;
        }
        const payload = JSON.parse(response.text);
        if (payload.status?.toLowerCase() === "failure") {
            console.warn("[GeniusSchoolCategory] API returned status=failure");
            return null;
        }
        const schoolFees = readSchoolFees(payload) ?? null;
        console.log("[GeniusSchoolCategory] success", { schoolFees });
        return schoolFees;
    }
    catch (error) {
        console.warn("[GeniusSchoolCategory] API error", { url, error });
        return null;
    }
}
